import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiTextField {
    constructor() {

    }

    createLabel() {
    }

    createTextField() {
    }

    textFieldText() {
    }
}
